import { z } from "zod";
import { ZMultiplacerModuleKey } from "./foundationSchema";
export const ZSharedViewCamera = z.object({
    rotation: z.number(),
    // DeckBimViewer uses logarithmic zoom, including zero and negative values.
    zoom: z.number().min(-5).max(20),
    centerWorld: z.object({
        x: z.number(),
        y: z.number(),
    }),
});
/** Navigation context for opening a shared-link snapshot. */
export const ZViewSnapshotContext = z.object({
    module: ZMultiplacerModuleKey,
    floorName: z.string().min(1),
    // Stable across IFC exports; resolve current globalId/jobId when opening the link.
    building: z.string().trim().min(1),
    camera: ZSharedViewCamera,
    // An absent room means no selection, regardless of the recipient's local state.
    selectedSpaceNumber: z.string().min(1).optional(),
});
